import React, { Fragment } from 'react';
import moment from 'moment';
import {
    Button, Modal, ModalHeader, ModalBody, ModalFooter,
    Col, Form, FormGroup, Label, Input, Row
} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { getAbuse } from 'API/AbuseAPI';
import { toast } from 'react-toastify';

class ReportedUrlModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            modal: this.props.open,
            record: this.dummyRecord()
        };

        this.dummyRecord = this.dummyRecord.bind(this);
        this.loadRecord = this.loadRecord.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    dummyRecord() {
        return {
            url: "",
            sha256: "",
            submission: "",
            type: "",
            status: "",
            updated: "",
            user_id: "",
            user_ip: ""
        }
    }

    componentDidMount() {
        this.loadRecord(this.props.id)
    }

    loadRecord(id) {
        getAbuse(this.props.id).then((result) => {
            this.setState({
                record: result.data
            })
        }).catch((error) => {
            console.error("Error fetching abuse record:", error);
            toast.error(this.props.t('reported_urls.error_fetching_record'));
        });
    }

    toggle() {
        if (this.state.modal && typeof this.props.onClose === 'function') {
            this.props.onClose(); // call onClose when closing
        }
        this.setState({
            modal: !this.state.modal,
            record: this.dummyRecord()
        });
    }

    render() {
        const { t, i18n } = this.props;

        const nCols = 4;
        const readOnly = true;

        return (
            <Fragment>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}
                    size='xl' scrollable={true}>
                    <ModalHeader toggle={this.toggle}>{t('reported_urls.record')}</ModalHeader>
                    <ModalBody>
                        <Form onSubmit={(e) => { e.preventDefault(); }}>
                            <Row>
                                <Col md={nCols}>
                                    <FormGroup>
                                        <Label for="url">{t('reported_urls.url')}</Label>
                                        <Input type="text" name="url" id="url"
                                            value={this.state.record.url} readOnly={readOnly} />
                                    </FormGroup>
                                </Col>
                                <Col md={nCols}>
                                    <FormGroup>
                                        <Label for="sha256">{t('reported_urls.sha256')}</Label>
                                        <Input type="text" name="sha256" id="sha256"
                                            value={this.state.record.sha256} readOnly={readOnly} />
                                    </FormGroup>
                                </Col>
                                <Col md={nCols}>
                                    <FormGroup>
                                        <Label for="submission">{t('reported_urls.submission')}</Label>
                                        <Input type="text" name="submission" id="submission"
                                            value={moment(this.state.record.submission).local().format("DD-MM-YYYY hh:mm:ss a")} readOnly={readOnly} />
                                    </FormGroup>
                                </Col>
                                <Col md={nCols}>
                                    <FormGroup>
                                        <Label for="type">{t('reported_urls.type')}</Label>
                                        <Input type="text" name="type" id="type"
                                            value={this.state.record.type} readOnly={readOnly} />
                                    </FormGroup>
                                </Col>
                                <Col md={nCols}>
                                    <FormGroup>
                                        <Label for="status">{t('reported_urls.status')}</Label>
                                        <Input type="text" name="status" id="status"
                                            value={this.state.record.status} readOnly={readOnly} />
                                    </FormGroup>
                                </Col>
                                <Col md={nCols}>
                                    <FormGroup>
                                        <Label for="updated">{t('reported_urls.updated')}</Label>
                                        <Input type="text" name="updated" id="updated"
                                            value={moment(this.state.record.updated).local().format("DD-MM-YYYY hh:mm:ss a")} readOnly={readOnly} />
                                    </FormGroup>
                                </Col>
                                <Col md={nCols}>
                                    <FormGroup>
                                        <Label for="user_id">{t('reported_urls.user_id')}</Label>
                                        <Input type="text" name="user_id" id="user_id"
                                            value={this.state.record.user_id} readOnly={readOnly} />
                                    </FormGroup>
                                </Col>
                                <Col md={nCols}>
                                    <FormGroup>
                                        <Label for="user_ip">{t('reported_urls.user_ip')}</Label>
                                        <Input type="text" name="user_ip" id="user_ip"
                                            value={this.state.record.user_ip} readOnly={readOnly} />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="link" onClick={this.toggle}>{t('actions.close')}</Button>
                    </ModalFooter>
                </Modal>
            </Fragment>
        );
    }
}

export default withTranslation()(ReportedUrlModal);
